import React from 'react'
import { ChevronLeft, ChevronRight } from '@material-ui/icons'
import { useTranslate } from 'react-admin'

const ChevronNext = ({ ...props }) => {
  const t = useTranslate()
  return <ChevronLeft {...props} />
}

export default ChevronNext